import { render, staticRenderFns } from "./FormTextItem.vue?vue&type=template&id=652e98f4"
import script from "./FormTextItem.vue?vue&type=script&lang=js"
export * from "./FormTextItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652e98f4')) {
      api.createRecord('652e98f4', component.options)
    } else {
      api.reload('652e98f4', component.options)
    }
    module.hot.accept("./FormTextItem.vue?vue&type=template&id=652e98f4", function () {
      api.rerender('652e98f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormTextItem.vue"
export default component.exports